import { DefaultLayout } from "../../components/DefaultLayout/DefaultLayout";
import "./ContactPage.css";
import { Box, Center, Group, SimpleGrid, Space, Stack, Text, ThemeIcon } from "@mantine/core";
import { IconMail, IconPhone } from "@tabler/icons-react";

export const ContactPage = (): JSX.Element => {
    return (
        <DefaultLayout showNavBar={true} showSearchBar={true} showFooter={true}>
            <Box>
                <div className="contact-hero-bleed">
                    <div className="contact-hero-container">
                        <Box pt={'6em'} pb={'6em'} pl={'1em'} pr={'1em'}>
                            <Center>
                                <Text ta={'center'} fw={'bold'} c="#1F2937" visibleFrom="md" fz={44}>Get In Touch</Text>
                                <Text ta={'center'} fw={'bold'} c="#1F2937" hiddenFrom="md" fz={30}>Get In Touch</Text>
                            </Center>
                            <Center>
                                <Text ta={'center'} c={'#4B5563'}>We're always available to discuss any questions or concerns you might have about our group</Text>
                            </Center>
                        </Box>
                    </div>
                </div>
                <Space h={'6em'} />
                <SimpleGrid ml={'5%'} mr={'5%'} cols={{ base: 1, md: 2 }}>
                    <Box className="hover-shadow" p={'2em'} style={{backgroundColor: '#f7f9fa', borderRadius: '1em', border: '1px solid #E5E7EB'}}>
                        <Stack>
                            <Text fz={24} c="#1F2937" fw={'bold'}>Contact Info</Text>
                            <Group>
                                <ThemeIcon c={'#cc7800'} color={'#eedfc8'} radius={'xl'} size={'xl'}>
                                    <IconPhone />
                                </ThemeIcon>
                                <div>
                                    <Text c={'#4B5563'}>Phone</Text>
                                    <Text fw={'bold'}>(631) 678-1210</Text>
                                </div>
                            </Group>
                            <Group wrap="nowrap">
                                <ThemeIcon c={'#cc7800'} color={'#eedfc8'} radius={'xl'} size={'xl'}>
                                    <IconMail />
                                </ThemeIcon>
                                <div>
                                    <Text c={'#4B5563'}>Email</Text>
                                    <Text fw={'bold'}>info@methodmaterials.com</Text>
                                </div>
                            </Group>
                        </Stack>
                    </Box>
                    <Box className="hover-shadow" p={'2em'} style={{backgroundColor: '#f7f9fa', borderRadius: '1em', border: '1px solid #E5E7EB'}}>
                        <Stack>
                            <Text fz={24} c="#1F2937" fw={'bold'}>Hours of Operation</Text>
                            <Group wrap="nowrap" justify="space-between">
                                <Text c={'#4B5563'}>Mon – Sat</Text>
                                <Text fw={'bold'}>7:00 AM – 5:00 PM</Text>
                            </Group>
                            <Group justify="space-between">
                                <Text c={'#4B5563'}>Sun</Text>
                                <Text fw={'bold'}>Closed</Text>
                            </Group>
                        </Stack>
                    </Box>
                </SimpleGrid>
                <Space h={'6em'} />
            </Box>
        </DefaultLayout>
    );
};